// extracted by mini-css-extract-plugin
export default {"earnText":"EarnText_earnText__0w9kn","sum":"EarnText_sum__BR0tq"};